import { ERROR_LEVELS, SENTRY_CABINET } from '@user-portal/sentry-utils';
import { takeEvery } from 'redux-saga/effects';

import { handleErrorAction } from './actions';

import { HANDLE_ERROR_ACTION } from './actionTypes';

import sentry from 'services/Sentry/SentryInstance';

import { isApiClientError } from 'services/ApiClient';
import { logger } from '@user-portal/logger';

function* handleErrorSaga({ payload: { error, data } }: ReturnType<typeof handleErrorAction>) {
    if (isApiClientError(error)) {
        return;
    }

    logger.error('Logging error from handleErrorSaga:', { error, data });

    yield sentry.logError(error, SENTRY_CABINET, ERROR_LEVELS.ERROR, {
        ...data,
    });
}

export default function* watchHandleErrorAction() {
    yield takeEvery(HANDLE_ERROR_ACTION, handleErrorSaga);
}
